module.exports = __webpack_public_path__ + "static/article-image-ad973651521e0fa1af2bf216a1737ad9.jpg";